import { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import ContractDepositsAnalytics from '@/components/contracts/ContractDepositsAnalytics';
import ContractDepositsRecords from '@/components/contracts/ContractDepositsRecords';
import CreateDepositSheet from '@/components/contracts/deposits/CreateDepositSheet';
import { Button } from '@/components/ui/button';
import { PiggyBank, Plus } from 'lucide-react';

export default function ContractDeposits() {
    const [createOpen, setCreateOpen] = useState(false);
    // Controlled so the page opens on the working surface (Records), not Analytics.
    const [tab, setTab] = useState('records');

    return (
        <div className="space-y-6 animate-fade-in px-4 sm:px-6 lg:px-8 pt-6 pb-12">
            {/* Header */}
            <div className="flex items-start justify-between">
                <div>
                    <div className="flex items-center gap-3 mb-1">
                        <PiggyBank className="h-7 w-7 text-muted-foreground" />
                        <h1 className="text-3xl font-semibold tracking-tight">Contract Deposits</h1>
                    </div>
                    <p className="text-sm text-muted-foreground ml-10">
                        Deposits received from drivers — assign them to contracts, or refund them.
                    </p>
                </div>
                <Button onClick={() => setCreateOpen(true)}>
                    <Plus className="h-4 w-4 mr-2" />
                    Record Deposit
                </Button>
            </div>

            <Tabs value={tab} onValueChange={setTab} className="space-y-6">
                <TabsList>
                    <TabsTrigger value="analytics">Analytics</TabsTrigger>
                    <TabsTrigger value="records">Records</TabsTrigger>
                </TabsList>

                <TabsContent value="analytics">
                    <ContractDepositsAnalytics />
                </TabsContent>

                <TabsContent value="records">
                    <ContractDepositsRecords onRecordDeposit={() => setCreateOpen(true)} />
                </TabsContent>
            </Tabs>

            <CreateDepositSheet open={createOpen} onOpenChange={setCreateOpen} />
        </div>
    );
}
